/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest,
  PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationResponse,
  PostApiV1CourseregistrationEnrollmentBatchStatusChange400,
  PostApiV1CourseregistrationEnrollmentBatchStatusChange401,
  PostApiV1CourseregistrationEnrollmentBatchStatusChange500,
} from "../../types/courseRegistrationEnrollmentController/PostApiV1CourseregistrationEnrollmentBatchStatusChange.ts";

function getPostApiV1CourseregistrationEnrollmentBatchStatusChangeUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/courseregistration/enrollment/batch-status-change` as const,
  };
  return res;
}

/**
 * @description Altera o status de matrícula de todos os alunos selecionados da turma para o status destino informado. Para status de cancelamento (Cancelado, Cancelado em Inscrição, Rejeitado), os campos StatusReasonId, SubStatusReasonId e Observation são obrigatórios. Cancela parcelas em aberto e recusa vínculo de bolsa quando aplicável. **(Requer Authorization para autenticação)**
 * @summary Altera o status de matrícula de vários alunos em lote (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/batch-status-change}
 */
export async function postApiV1CourseregistrationEnrollmentBatchStatusChange(
  data?: PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange400
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange401
      | PostApiV1CourseregistrationEnrollmentBatchStatusChange500
    >,
    PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest
  >({
    method: "POST",
    url: getPostApiV1CourseregistrationEnrollmentBatchStatusChangeUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
